<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <tools excel="shop/products/export/excel" />
          <div class="row">
            <div class="col-12">
              <div class="float-left">
                <bita-bootbutton
                  title="افزودن محصول"
                  type="primary"
                  icon="fas fa-plus-square"
                  btn-width="200px"
                  @click.native="createProduct"
                  v-if="$acl.can('create', 'products')"
                />
                <bita-bootbutton
                  title="نرمال کردن محصول"
                  type="danger margin-rigth"
                  icon="fas fa-plus-square"
                  @click.native="normalizeDatabase"
                  v-if="$acl.can()"
                />
              </div>
              <div class="float-right">
                <bita-bootbutton
                  title="بروزرسانی قیمت"
                  type="warning"
                  icon="fas fa-file-upload"
                  btn-width="200px"
                  @click.native="openUpdateModal"
                  v-if="$acl.can('create', 'products')"
                />
              </div>
            </div>
          </div>
          <hr />
          <bita-form ref="filterForm">
            <div slot="body">
              <div class="row">
                <bita-input
                  type="text"
                  name="name"
                  label="جستجو"
                  validation-container-class="col-lg-4"
                  input-class="form-control"
                  v-model.lazy="filters.search"
                  @keyup.enter.prevent="loadData"
                />
                <div class="col-lg-4">
                  <a class="margin-top btn btn-success" @click="loadData()">
                    جستجو
                  </a>
                  <a
                    class="margin-top margin-right btn btn-warning"
                    @click="resetFilters()"
                  >
                    پاک سازی
                  </a>
                </div>
                <more-filter ref="moreFilter">
                  <bita-input
                    type="text"
                    name="barcode"
                    label="بارکد"
                    validation-container-class="col-lg-2"
                    input-class="form-control"
                    v-model.lazy="filters.barcode"
                    @keyup.enter.prevent="loadData"
                  />
                  <bita-input
                    type="text"
                    name="code"
                    label="کد محصول"
                    validation-container-class="col-lg-2"
                    input-class="form-control"
                    v-model.lazy="filters.code"
                    @keyup.enter.prevent="loadData"
                  />
                  <bita-select
                    name="status"
                    ref="status"
                    label="وضعیت"
                    :validation-container-class="colWith"
                    input-class="form-control"
                    :data-source="statuses"
                    data-text-field="title"
                    data-value-field="id"
                    v-model="filters.is_saleable"
                  />
                  <bita-select
                    name="brand_id"
                    ref="brandSelect"
                    label="برند"
                    :validation-container-class="colWith"
                    input-class="form-control"
                    :data-source="brands"
                    data-text-field="name"
                    data-value-field="id"
                    v-model="filters.brand_id"
                  />
                  <bita-multiselect
                    name="standard_id"
                    ref="standardSelect"
                    label="استاندارد"
                    :validation-container-class="colWith"
                    input-class="form-control"
                    :data-source="standards"
                    data-text-field="name"
                    data-value-field="id"
                    v-model="filters.standard_id"
                  />
                  <bita-treeselect
                    name="category_id"
                    ref="categoryTreeselect"
                    label="گروه"
                    :validation-container-class="colWith"
                    input-class="form-control"
                    :data-source="categories"
                    data-text-field="name"
                    data-value-field="id"
                    v-model="filters.category_id"
                  />
                  <bita-select
                    name="is_recommended"
                    ref="recommendedSelect"
                    label="پیشنهاد لحظه ای"
                    :validation-container-class="colWith"
                    input-class="form-control"
                    :data-source="[
                      { id: 0, name: 'خیر' },
                      { id: 1, name: 'بله' },
                    ]"
                    data-text-field="name"
                    data-value-field="id"
                    v-model="filters.is_recommended"
                  />
                </more-filter>
              </div>
            </div>
          </bita-form>
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :grid-server-side="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
            :resizable="true"
            :page-size="pageSize"
            :current-page="currentPage"
            :has-row-number="true"
          />
        </div>
      </bita-ibox>
    </div>
    <bita-modal
      id="info-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
    >
      <div slot="body">
        <info-form
          ref="infoForm"
          @on-update="(e) => infoUpdated(e)"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
      <div slot="footer">
        <bita-bootbutton
          title="بروزرسانی"
          type="primary"
          icon="fas fa-save"
          btn-width="150px"
          @click.native="save('infoForm')"
          :disabled="isLoadingModal"
        />
      </div>
    </bita-modal>
    <bita-modal
      id="details-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
    >
      <div slot="body">
        <product-detail-form
          ref="detailForm"
          @on-update="(e) => detailUpdated(e)"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
      <div slot="footer">
        <bita-bootbutton
          title="بروزرسانی"
          type="primary"
          icon="fas fa-save"
          btn-width="150px"
          @click.native="save('detailForm')"
          :disabled="isLoadingModal"
        />
      </div>
    </bita-modal>
    <bita-modal
      id="images-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
      @close="(e) => $refs.imagesForm.reset()"
    >
      <div slot="body">
        <product-images-form
          ref="imagesForm"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
      <!-- <div slot="footer">
        <bita-bootbutton
          title="بروزرسانی"
          type="primary"
          icon="fas fa-save"
          btn-width="150px"
          @click.native="$refs.infoForm.save()"
        />
      </div> -->
    </bita-modal>

    <bita-modal
      id="vehicle-types-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
      @close="(e) => $refs.vehicleTypesForm.reset()"
    >
      <div slot="body">
        <product-vehicle-types-form
          ref="vehicleTypesForm"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
    </bita-modal>

    <bita-modal
      id="prices-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
      @close="(e) => pricesUpdated(e)"
    >
      <div slot="body">
        <product-prices-form
          ref="pricesForm"
          @on-update="(e) => pricesUpdated(e)"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
      <div slot="footer">
        <bita-bootbutton
          title="بروزرسانی"
          type="primary"
          icon="fas fa-save"
          btn-width="150px"
          @click.native="save('pricesForm')"
          :disabled="isLoadingModal"
        />
      </div>
    </bita-modal>

    <bita-modal
      id="features-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
      @close="(e) => $refs.featuresForm.reset()"
    >
      <div slot="body">
        <product-feature-form
          ref="featuresForm"
          @on-update="(e) => featuresUpdated(e)"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
      <div slot="footer">
        <bita-bootbutton
          title="بروزرسانی"
          type="primary"
          icon="fas fa-save"
          btn-width="150px"
          @click.native="save('featuresForm')"
          :disabled="isLoadingModal"
        />
      </div>
    </bita-modal>

    <bita-modal
      id="seo-form"
      :title="formTitle"
      :modal-lg="true"
      :is-loading="isLoadingModal"
      @close="(e) => $refs.seoForm.reset()"
    >
      <div slot="body">
        <product-seo
          ref="seoForm"
          @on-update="(e) => seoUpdated(e)"
          @is-loading="(e) => (isLoadingModal = e)"
        />
      </div>
      <div slot="footer">
        <bita-bootbutton
          title="بروزرسانی"
          type="primary"
          icon="fas fa-save"
          btn-width="150px"
          @click.native="save('seoForm')"
          :disabled="isLoadingModal"
        />
      </div>
    </bita-modal>
    <price-update-modal />
    <product-relation ref="productRelation" />
  </div>
</template>
<script>
import InfoForm from "./components/ProductInfoForm";
import ProductImagesForm from "./components/ProductImagesForm";
import ProductDetailForm from "./components/ProductDetailForm";
import ProductPricesForm from "./components/ProductCombinationPricesForm";
import ProductFeatureForm from "./components/ProductFeatureForm";
import PriceUpdateModal from "./components/PriceUpdateModal";
import ProductSeo from "./components/ProductSeo";
import ProductRelation from "./components/ProductRelation";
import ProductVehicleTypesForm from "./components/ProductVehicleTypesForm.vue";
import {
  productApi,
  categoryApi,
  brandApi,
  standardApi,
  measureApi,
} from "@/api/apiManagement";
import MoreFilter from "@/components/MoreFilter.vue";
import Tools from "../../../components/Tools.vue";
export default {
  components: {
    ProductVehicleTypesForm,
    InfoForm,
    ProductImagesForm,
    ProductDetailForm,
    ProductPricesForm,
    ProductFeatureForm,
    PriceUpdateModal,
    ProductSeo,
    MoreFilter,
    ProductRelation,
    Tools,
  },

  data() {
    return {
      statuses: [
        { id: 1, title: "فعال" },
        { id: 0, title: "غیر فعال" },
      ],
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "فروشگاه", link: "" },
        {
          title: "مدیریت محصولات",
          link: "/management/roles",
          active: true,
        },
      ],
      colWith: "col-lg-2",
      pageSize: 30,
      currentPage: 1,
      isLoadingForm: false,
      isLoadingGrid: false,
      isLoadingModal: false,
      moreFilter: null,
      formTitle: "",
      permissions: [],
      categories: [],
      brands: [],
      standards: [],
      role: {
        name: "",
        permissions: [],
      },
      editForm: {},
      filters: {},
    };
  },
  computed: {
    gridColumns() {
      return [
        // { title: "#", template: this.$getTemplate, width: "40px" },
        { field: "name", title: "نام محصول", width: 300 },
        { field: "visit_count", title: "بازدیدها" },
        { field: "coefficient", title: "ضریب فروش" },
        {
          field: "is_saleable",
          title: "وضعیت فروش",
          template: this.saleableRender,
          // width: 100,
        },

        {
          field: "is_recommended",
          title: "پیشنهاد",
          template: this.recommendedRender,
          // width: 80,
        },
        {
          field: "active",
          title: "وضعیت",
          template: this.activeRender,
          // width: 80,
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          // width: 150,
        },
        {
          title: "عملیات",
          width: 400,
          command: this.getGridColumns(),
        },
      ];
    },
  },
  mounted() {
    this.moreFilter = this.$refs.moreFilter;

    this.moreFilter.setLoading(true);
    var proms = [categoryApi.getCategories(), brandApi.get()];
    if (this.$acl.can("view", "standards")) {
      proms.push(standardApi.get());
    }
    Promise.all(proms).then((res) => {
      this.moreFilter.setLoading(false);
      this.categories = res[0].data.entity;
      this.brands = res[1].data.entity;
      if (this.$acl.can("view", "standards"))
        this.standards = res[2].data.entity;
    });
    // this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    getGridColumns() {
      let commands = [];
      if (this.$acl.can("edit", "products")) {
        commands.push({
          text: "edit",
          click: this.edit,
          template: this.gridButtons.edit,
        });
        commands.push({
          text: "items",
          click: this.editDetails,
          template: this.gridButtons.items,
        });
        commands.push({
          text: "info",
          click: this.editFeatures,
          template: this.gridButtons.info,
        });
        commands.push({
          text: "images",
          click: this.editImages,
          template: this.gridButtons.images,
        });
        commands.push({
          text: "vehicle",
          click: this.editVehicleTypes,
          template: this.gridButtons.vehicle,
        });
        commands.push({
          text: "prices",
          click: this.editPrices,
          template: this.gridButtons.prices,
        });
        commands.push({
          text: "seo",
          click: this.editSeo,
          template: this.gridButtons.seo,
        });
        commands.push({
          text: "saleSatus",
          click: this.editStatus,
          template: this.gridButtons.saleSatus,
        });
      }
      if (this.$acl.can("view", "productrelations"))
        commands.push({
          text: "relation",
          click: this.productRelation,
          template: this.gridButtons.relation,
        });
      commands.push({
        text: "view",
        click: this.viewProduct,
        template: this.gridButtons.view,
      });
      if (this.$acl.can("delete", "products"))
        commands.push({
          text: "delete",
          click: this.delete,
          template: this.gridButtons.delete,
        });

      return commands;
    },
    save(ref) {
      this.$refs[ref].save();
    },
    resetFilters() {
      this.filters = {};
      this.$refs.filterForm.reset();
      let selects = Object.values(this.$refs);
      selects.forEach((el) => {
        if (el && el.emptyKendo) el.emptyKendo();
      });
    },
    saleableRender(e) {
      let color = e.is_saleable == 1 ? "green" : "red";
      return `<span class="fas fa-shopping-bag" title="${this.getStringIsSalable(
        e.is_saleable
      )}" style="color:${color}"></span>`;
    },
    activeRender(e) {
      let view = e.active == 1 ? "fas fa-lock-open" : "fas fa-lock";
      let color = e.active == 1 ? "green" : "red";
      return `<span class="${view}" style="color:${color}"></span>`;
    },
    recommendedRender(e) {
      let view = this.isActive(e.is_recommended) ? "fa" : "far";
      let color = this.isActive(e.is_recommended) ? "gold" : "gray";
      return `<span class="${view} fa-star" style="color:${color}"></span>`;
    },
    formSucceeded(ref) {
      this.loadData();
      this.formTitle = "";
      this.$refs.infoForm.setInitialValue({});
      this.$toggleModal("#info-form");
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    readData(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      this.isLoadingGrid = true;
      this.$resetGrid();
      productApi
        .getProductsPaginated({
          page_size: this.pageSize,
          page: this.currentPage,
          ...this.filters,
        })
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    edit(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.isLoadingGrid = true;
      productApi
        .getProductInfo(product.id)
        .then((res) => {
          this.$refs.infoForm.setInitialValue({
            ...res.data.entity,
            category_id: String(product.category_id),
          });
          this.formTitle = `ویرایش اطلاعات ${product.name}`;
          this.$toggleModal("#info-form");
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    editImages(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.imagesForm.setInitialValue(product);
      this.formTitle = `ویرایش تصاویر ${product.name}`;
      this.$toggleModal("#images-form");
    },
    editDetails(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.detailForm.setInitialValue(product);
      this.formTitle = `ویرایش جزئیات ${product.name}`;
      this.$toggleModal("#details-form");
    },
    isActive(status) {
      return status == 1;
    },
    getStringIsSalable(isSalable) {
      return isSalable == 1 ? "قابل فروش" : "کاتالوگ";
    },
    editStatus(e) {
      let { id, name, is_saleable } = this.$refs.grid.getSelectedGridRow(e);
      this.$alert(
        "question",
        `آیا از ${this.getStringIsSalable(
          !is_saleable
        )} کردن ${name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          productApi.toggleStatus(id).then(() => {
            this.loadData();
          });
        }
      });
    },
    editSeo(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.seoForm.setInitialValue(product);
      this.$toggleModal("#seo-form");
    },
    viewProduct(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      window.open(product.url);
    },
    productRelation(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.productRelation.setInitialData(product);
      this.$toggleModal("#product-relation");
    },
    editFeatures(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.featuresForm.setInitialValue(product);
      this.formTitle = `ویرایش مشخصات ${product.name}`;
      this.$toggleModal("#features-form");
    },

    editVehicleTypes(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.vehicleTypesForm.setInitialValue(product);
      this.formTitle = `ویرایش محموله ${product.name}`;
      this.$toggleModal("#vehicle-types-form");
    },

    editPrices(e) {
      let product = this.$refs.grid.getSelectedGridRow(e);
      this.$refs.pricesForm.setInitialValue(product);
      this.formTitle = `ویرایش قیمت ها ${product.name}`;
      this.$toggleModal("#prices-form");
    },
    infoUpdated(_data) {
      this.loadData();
      this.formTitle = "";
      this.$refs.infoForm.setInitialValue({});
      this.$toggleModal("#info-form");
    },
    detailUpdated(_data) {
      this.formTitle = "";
      this.$refs.detailForm.setInitialValue({});
      this.$toggleModal("#details-form");
    },
    pricesUpdated(_data) {
      this.formTitle = "";
      this.$refs.pricesForm.reset();
      this.$toggleModal("#prices-form");
    },
    featuresUpdated() {
      this.formTitle = "";
      this.$toggleModal("#features-form");
    },
    seoUpdated() {
      this.formTitle = "";
      this.$toggleModal("#seo-form");
    },
    delete(e) {
      let role = this.$refs.grid.getSelectedGridRow(e);
      this.$alert("question", `آیا از حذف ${role.name} اطمینان دارید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          productApi
            .deleteProduct(role.id)
            .then((res) => {
              this.$izitoast("success", "با موفقیت حذف شد", "موفق");
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    createProduct() {
      this.$router.push({ path: "/shop/products/create" });
    },

    normalizeDatabase() {
      this.isLoadingGrid = true;
      productApi
        .normalizeDatabase()
        .then((e) => {
          this.$alert("success", "نرمال سازی شد");
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },

    openUpdateModal() {
      this.$toggleModal("#priceupdate-modal");
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
a.margin-top {
  margin-top: 27px;
}
a.margin-right {
  margin-right: 5px;
}
.margin-rigth {
  margin-right: 16px;
}
</style>

<style>
[data-field="is_saleable"],
[data-field="is_recommended"] {
  text-align: center !important;
}
</style>
